// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"451b8f0d","239":"9e364194","453":"4bf07440","455":"f2cb21c2"}[chunkId] + ".chunk.js";
};